import client from '@/api/client'
import routes from './routes'

let apiOrgstructure = {
  companiesList(data) {
    return client.post( routes.companiesList, data ).then(response => response.data)
  },
  
  updateCompany(id, data) {
    return client.patch(`${routes.updateCompany}/${id}`, data ).then(response => response.data)
  },
  
  deleteCompany(id){
    return client.delete(`${routes.deleteCompany}/${id}`).then(response => response.data)
  },
  
  companyHardDelete(id){
    return client.delete(`${routes.companyHardDelete}/${id}`).then(response => response.data)
  },
  
  restoreCompany(id){
    return client.get(`${routes.restoreCompany}/${id}`).then(response => response.data)
  },
  
  companyTree(id){
    return client.get(`${routes.companyTree}/${id}`).then(response => response.data.tree)
  },
  
  containersTree(id, type){
    return client.get(`${routes.containersTree}/${id}/${type}`).then(response => response.data)
  },
  
  updateContainer(id, data){
    return client.patch(`${routes.updateContainer}/${id}`, data ).then(response => response.data)
  },
  
  deleteContainer(id){
    return client.delete(`${routes.deleteContainer}/${id}`).then(response => response.data)
  },
  
  containerHardDelete(id){
    return client.delete(`${routes.containerHardDelete}/${id}`).then(response => response.data)
  },
  
  restoreContainer(id){
    return client.get(`${routes.restoreContainer}/${id}`).then(response => response.data)
  },
  
  updatePost(id, data){
    return client.patch(`${routes.updatePost}/${id}`, data ).then(response => response.data)
  },
  
  deletePost(id){
    return client.delete(`${routes.deletePost}/${id}`).then(response => response.data)
  },
  
  postHardDelete(id){
    return client.delete(`${routes.postHardDelete}/${id}`).then(response => response.data)
  },
  
  restorePost(id){
    return client.get(`${routes.restorePost}/${id}`).then(response => response.data)
  }
}
export default apiOrgstructure


// WEBPACK FOOTER //
// ./src/api/orgstructure/index.js